(function () {
  function init() {
    var bar = document.querySelector('.sticky-atc');
    if (!bar) return;

    var sectionId = bar.dataset.sectionId;
    var mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!mainButton) return;

    var stickyButton = bar.querySelector('.sticky-atc__button');

    // Show the bar only after the main buy button has scrolled out of view
    // (above the viewport). rAF-throttled scroll listener rather than
    // IntersectionObserver: IO misses instant jumps (e.g. back-to-top links)
    // where the button never crosses the viewport.
    var ticking = false;
    var updateVisibility = function () {
      ticking = false;
      var pastButton = mainButton.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('sticky-atc--visible', pastButton);
      bar.setAttribute('aria-hidden', pastButton ? 'false' : 'true');
    };
    var requestUpdate = function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateVisibility);
      }
    };
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    updateVisibility();

    // The theme's placeholder-variant-guard disables the main button until a
    // real size/dexterity is chosen. In that state the sticky button stays
    // active as "Choose size" and scrolls the shopper to the variant picker.
    var isPlaceholderBlocked = function () {
      return (
        mainButton.dataset.placeholderBlocked === 'true' ||
        (mainButton.hasAttribute('disabled') &&
          !!document.querySelector('variant-selects, variant-radios'))
      );
    };

    var syncState = function () {
      if (isPlaceholderBlocked()) {
        stickyButton.disabled = false;
        stickyButton.textContent = 'Choose size';
        stickyButton.dataset.mode = 'choose';
        return;
      }
      stickyButton.dataset.mode = 'add';
      var disabled =
        mainButton.hasAttribute('disabled') ||
        mainButton.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = disabled;
      var label = mainButton.querySelector('span');
      if (label && label.textContent.trim()) {
        stickyButton.textContent = label.textContent.trim();
      }
    };

    stickyButton.addEventListener('click', function () {
      if (stickyButton.dataset.mode === 'choose') {
        var picker = document.querySelector('variant-selects, variant-radios');
        if (picker) {
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      // Proxy to the real submit button so product-form.js handles the
      // add-to-cart (cart drawer/notification, loading state, errors).
      mainButton.click();
    });

    syncState();

    new MutationObserver(syncState).observe(mainButton, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
